import {Box, useTheme} from '@mui/material';

import MainContainer from 'src/components/common/MainContainer';

import PublicPageContainer from 'src/features/Public/PublicPageContainer';

import TradeDataMainSearch from "src/features/TradeDataMainSearch";

const TradeDataPublicPage = () => {
  const { spacing } = useTheme();
  return (
    <PublicPageContainer visiblePowerByBadge={false}>
      <MainContainer maxWidth="md" sx={{ mt: 0, px: spacing(3) }}>
        <Box mt={8}>
          <TradeDataMainSearch/>
        </Box>
      </MainContainer>
    </PublicPageContainer>
  );
};

export default TradeDataPublicPage;
